export const ownerDocument = (node: Node | null | undefined): Document => {
  return (node && node.ownerDocument) || document;
};
